import React from 'react';

function NavbarLiga({onLogin, handleLigaClick, ligaList, selectedLiga}) {

    return (
        <nav className="navbarliga">
            {ligaList.map((liga) => (
                <button key={liga.id} onClick={() => handleLigaClick(liga)}
                    className={liga === selectedLiga ? 'active' : ''}>
                    {liga.name}
                </button>

            ))}

            {/* ... Weitere Teile der Navbar, wie Logout-Button, etc. ... */}
        </nav>
    );
}

export default NavbarLiga;
